import { ReactElement } from 'react';
import { useViewProvider } from "../contexts/view-provider-context/ViewProvider";

export function ModalContent(): ReactElement {
  const viewProvider = useViewProvider();

  return viewProvider.renderModalContent();
}
